module.exports = __webpack_public_path__ + "img/cooperation4.3f600498.png";